// extracted by mini-css-extract-plugin
export var bottomRow = "styles-module--bottomRow--3dce3";
export var column = "styles-module--column--26760";
export var columns = "styles-module--columns--0c337";
export var companyDescription = "styles-module--companyDescription--89ab6";
export var companyLabel = "styles-module--companyLabel--2abb5";
export var companyLogo = "styles-module--companyLogo--d17b9";
export var companyName = "styles-module--companyName--ef238";
export var container = "styles-module--container--74ca1";
export var div = "styles-module--div--2e3b1";
export var heading = "styles-module--heading--add24";
export var icon = "styles-module--icon--96fa9";
export var link = "styles-module--link--5d296";
export var links = "styles-module--links--d4286";
export var logo = "styles-module--logo--0abf3";
export var productIcon = "styles-module--productIcon--fc4ee";
export var socialIcon = "styles-module--socialIcon--2a750";
export var socialIcons = "styles-module--socialIcons--c2f36";
export var wide = "styles-module--wide--e38ba";
export var wrapper = "styles-module--wrapper--71807";